import React from 'react';

import { ThreeDotsLoader } from '../shared/ThreeDotsLoader';

import './FavoriteAccount.scss';

const FavoriteAccountSkeleton = (): JSX.Element => {
    return (
        <div className="sgw-favorite-account" data-testid="favorite-account-loader">
            <ThreeDotsLoader />
        </div>
    );
};

export default FavoriteAccountSkeleton;
